import { type FC } from "react";

import { Button, Colors } from "@snapchat/snap-design-system";
import { MembersIcon } from "@snapchat/snap-design-system-icons";

import { useFeatureGates } from "../../../../cof-feature-gates/hooks";
import { CofConfigId } from "../../../../gql-generated/types";
import { PageHeader, PageHeaderContainer } from "../../../../layout/components";
import { Flexbox } from "../../../../shared/components";
import { FolderSelectionDropdown } from "../../../../shared/components/folder-selection";
import { BUSINESS_MANAGER_URL } from "../../../../shared/constants";
import { useSelectedLensCentralOrganizationNotIncludesCamkitOrgs } from "../../../../shared/hooks";
import { useSelectedOrganization } from "../../../../shared/hooks/useSelectedOrganization";
import { truncate } from "../../../../shared/styles";
import { openWindow } from "../../../../shared/utils/browser";

const handleManageMembersButtonClick = (organizationId?: string) => {
    const businessManagerOrganizationUrl = `${BUSINESS_MANAGER_URL}/${organizationId}/settings/members`;
    openWindow(businessManagerOrganizationUrl);
};

export const PageOrganizationHeaderV3: FC = () => {
    const { configs } = useFeatureGates();
    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;

    const selectedOrganizationV3 = useSelectedLensCentralOrganizationNotIncludesCamkitOrgs();
    const selectedOrganization = useSelectedOrganization();

    const orgName = isMyLensesOrgsV2Enabled ? selectedOrganization?.name : selectedOrganizationV3?.name;
    const orgId = isMyLensesOrgsV2Enabled ? selectedOrganization?.id : selectedOrganizationV3?.id;

    return (
        <Flexbox justifyContent="space-between">
            <PageHeaderContainer>
                <PageHeader className={truncate}>{orgName}</PageHeader>
                <FolderSelectionDropdown />
            </PageHeaderContainer>

            <Button
                type="primary"
                onClick={() => {
                    handleManageMembersButtonClick(orgId);
                }}
            >
                <MembersIcon fill={Colors.WHITE} />
                Manage Members
            </Button>
        </Flexbox>
    );
};
